// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://rjtucjbqtcgxxancxryf.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJqdHVjamJxdGNneHhhbmN4cnlmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzc3Nzc5NDIsImV4cCI6MjA1MzM1Mzk0Mn0.qhcNJOmApM5dmaOPFeaMgpJ6xwo7j3QdFC3BpFQWhFE";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);